export enum PageTab {
  ABOUTME = 1,
  PRESENTATION = 2,
  SERVICES = 3,
}
